import { render } from "./canais-baileys.vue?vue&type=template&id=9453125e&scoped=true"
import script from "./canais-baileys.vue?vue&type=script&lang=js"
export * from "./canais-baileys.vue?vue&type=script&lang=js"

import "./canais-baileys.vue?vue&type=style&index=0&id=9453125e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9453125e"]])

export default __exports__